/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取剧院会员信息(新)
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  memberId: string,
  theaterId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/user-theatre-member/${memberId}/${theaterId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
